import styled from "styled-components"

import { minWidth } from "utils"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 3rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 4rem;
  `}
`

export const Quote = styled.blockquote`
  margin: 0 1.85rem;
  padding: 0.5rem 0 0.5rem 2.5rem;
  border-left: 5px solid #efefef;
  font-size: 1.6rem;
  line-height: 1.62;

  ${minWidth.tablet`
    margin: 0;
    font-size: 1.8rem;
    line-height: 1.56;
  `}

  ${minWidth.hamburgerLarge`
    border-width: 7px;
  `}
`
